(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ez-cro-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getNativeButton() {
      return document.querySelector(
        '.product__info-container .product-form__submit, .product__info-container product-form button[type="submit"]'
      );
    }

    function ensureCompatibility(nativeButton) {
      if (!nativeButton) return;
      var productInfo = nativeButton.closest('.product__info-container');
      if (!productInfo || productInfo.querySelector('[data-ez-cro-compatibility]')) return;

      var template = document.querySelector('[data-ez-cro-compat-template]');
      var productForm = nativeButton.closest('product-form') || nativeButton.closest('form');
      if (!template || !template.content || !productForm || !productForm.parentNode) return;

      var compatibility = template.content.firstElementChild.cloneNode(true);
      productForm.parentNode.insertBefore(compatibility, productForm);
    }

    function initEzCroProduct() {
      var sticky = document.querySelector('[data-ez-cro-sticky]');
      var stickyButton = document.querySelector('[data-ez-cro-add]');

      if (!sticky || !stickyButton) return;
      if (sticky.dataset.ezCroReady === 'true') return;
      sticky.dataset.ezCroReady = 'true';

      var ticking = false;

      function syncSticky() {
        ticking = false;
        var nativeButton = getNativeButton();

        if (!nativeButton) {
          sticky.hidden = true;
          return;
        }

        ensureCompatibility(nativeButton);

        var disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
        var passedNativeButton = nativeButton.getBoundingClientRect().bottom < 0;

        stickyButton.disabled = disabled;
        stickyButton.textContent = nativeButton.textContent.trim() || 'ADD TO CART';
        sticky.hidden = !passedNativeButton || disabled;
      }

      function requestSync() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(syncSticky);
      }

      stickyButton.addEventListener('click', function () {
        var nativeButton = getNativeButton();
        if (!nativeButton || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true') return;
        nativeButton.click();
        window.setTimeout(requestSync, 50);
        window.setTimeout(requestSync, 600);
      });

      window.addEventListener('scroll', requestSync, { passive: true });
      window.addEventListener('resize', requestSync);

      document.addEventListener('change', function () {
        window.setTimeout(requestSync, 50);
        window.setTimeout(requestSync, 500);
      });

      var productInfo = document.querySelector('product-info');
      if (productInfo) {
        var observer = new MutationObserver(requestSync);
        observer.observe(productInfo, { childList: true, subtree: true, attributes: true });
      }

      syncSticky();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initEzCroProduct);
    } else {
      initEzCroProduct();
    }

    document.addEventListener('shopify:section:load', initEzCroProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
